import { useState } from "react";
import { BiSupport } from "react-icons/bi";
// import { MdEmail } from "react-icons/md";

import { Nav, Modal, Button, Card } from "react-bootstrap";

import { Input, Select, Textarea } from "../Utility/FormElements";

export const supportSubjects = [
  { value: "label_not_printing", label: "Label Not Printing / Pop-up Blocked" },
  { value: "account_access", label: "Account Login / Access Issues" },
  { value: "password_reset", label: "Password Reset or Recovery" },
  { value: "subscription_change", label: "CDK Subscription / Plan Change" },
  { value: "technical_issue", label: "Technical Issue or Bug Report" },
  { value: "data_issue", label: "Data or Report Issue" },
  { value: "performance", label: "Performance / Slow Loading" },
  { value: "error_message", label: "Error Message Appearing" },
  { value: "app_not_working", label: "Website / App Not Working" },
  { value: "settings_help", label: "Question About Settings or Configuration" },
  { value: "update_info", label: "Request to Update Information" },
  { value: "other", label: "Other (please specify)" },
];

function ContactSupportPageNav() {
  const [show, setShow] = useState(false);
  const [subject, setSubject] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Nav.Link onClick={handleShow}>
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-x-1">
          <BiSupport className="tw-text-xl" />
          <div>Contact US</div>
        </div>
      </Nav.Link>

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title className="tw-flex-1">
            <div className="tw-text-center">Contact Support</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="tw-grid lg:tw-grid-cols-2 lg:tw-gap-4">
            <div className="lg:tw-border-r-2 lg:tw-border-y-0 lg:tw-border-l-0 lg:tw-border-r-gray-200 lg:tw-border-solid">
              <div className="tw-px-4">
                {/* 2 Support: Operation and IT relate issues */}

                <Card className="tw-mb-4">
                  <Card.Body>
                    <Card.Title>Operation Issues</Card.Title>

                    <Card.Text>
                      For assistance with order processing, shipping, or other
                      operational matters, contact our Operations Support team
                      at{" "}
                      <a href="mailto:OperationsSupport@diligentusa.com">
                        OperationsSupport@diligentusa.com
                      </a>
                    </Card.Text>
                  </Card.Body>
                </Card>

                <Card className="tw-mb-4">
                  <Card.Body>
                    <Card.Title>IT and Technical Issues</Card.Title>
                    <Card.Text>
                      For help with technical problems, software issues, or
                      error related reach out to our IT Support team at{" "}
                      <a href="mailto:DCPSupport@diligentusa.com">
                        DCPSupport@diligentusa.com
                      </a>
                    </Card.Text>
                  </Card.Body>
                </Card>

                {/* <Card className="tw-mb-4">
                  <Card.Body>
                    <Card.Title>Contact US</Card.Title>
                    <Card.Text>
                      Need to get in touch? Either fill out the form with your
                      inquiry or email us at{" "}
                      <a href="mailto:DCPSupport@diligentusa.com">
                        DCPSupport@diligentusa.com
                      </a>
                    </Card.Text>
                  </Card.Body>
                </Card> */}

                {/* Help Guide */}

                <Card>
                  <Card.Body>
                    <Card.Title>Need Help?</Card.Title>
                    <Card.Text>
                      Visit our <a href="/help-center">Help Center</a> for FAQs
                      and guides on using our platform.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <div>
              <div className="tw-grid tw-gap-y-2 tw:px-4">
                <Input label="Your Name *" name="name" type="text" />

                <Input label="Your Email *" name="email" type="email" />

                <Select
                  label="Subject *"
                  name="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                >
                  <option value="">Select a subject</option>

                  {supportSubjects.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>

                <Input
                  label="Attachment (optional)"
                  name="attachment"
                  type="file"
                />

                {subject === "label_not_printing" && (
                  <div>
                    Sorry to hear you’re having trouble printing labels. Please
                    make sure pop-ups are allowed for our site, as blockers can
                    interrupt printing. If the issue continues, share details
                    about your setup and any error messages you see
                  </div>
                )}

                <Textarea label="Message *" name="message" rows={5} />

                <div className="tw-text-right">
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </div>

                <p className=" tw-text-xs">
                  Tip: Please do not include any sensitive information such as
                  passwords or personal data. Including screenshots or
                  attachments and a detailed description of what happened will
                  help us resolve your issue faster.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ContactSupportPageNav;
